import {
  POSITION_SUCCESS,
  POSITION_ERROR,
  GETTING_POSITION,
  IP_REVERSE_GEOCODE_RESULTS_RECEIVED,
  LOCATION_SOURCE_IP_ADDRESS,
} from '../constants';
import { parseLocationFromReverseGeoCodeResult } from '../core/dapi/geoCode';

export default function positionReducer(state = {}, action) {
  switch (action.type) {
    case POSITION_SUCCESS:
      return {
        ...state,
        success: true,
        result: action.payload.value,
      };
    case POSITION_ERROR:
      return {
        ...state,
        success: false,
        result: null,
      };
    case GETTING_POSITION:
      return {
        ...state,
        gettingPosition: action.payload.value,
      };
    case IP_REVERSE_GEOCODE_RESULTS_RECEIVED:
      return {
        ...state,
        result: {
          ...parseLocationFromReverseGeoCodeResult(action.payload.value.results[0]),
          source: LOCATION_SOURCE_IP_ADDRESS,
        },
      };
    default:
      return state;
  }
}
